<template>
  <div>

    <el-form ref="registerForm" :model="addMovieForm" :rules="rules" label-width="80px" :hide-required-asterisk="true">
      <el-form-item label="片名" prop="movieName">
        <el-input v-model="addMovieForm.movieName" placeholder="请输入片名" clearable></el-input>
      </el-form-item>
      <el-form-item label="英文名" prop="englishName">
        <el-input v-model="addMovieForm.englishName" placeholder="请输入英文名" clearable></el-input>
      </el-form-item>
      <el-form-item label="年代" prop="years">
        <el-input v-model="addMovieForm.years" placeholder="请再次输入年代" clearable></el-input>
      </el-form-item>
      <el-form-item label="产地" prop="orginPlace">
        <el-input v-model="addMovieForm.orginPlace" placeholder="请输入产地" clearable></el-input>
      </el-form-item>

      <el-form-item label="类别" prop="category">
        <el-input v-model="addMovieForm.category" placeholder="请输入类别" clearable></el-input>
      </el-form-item>

      <el-form-item label="语言" prop="language">
        <el-input v-model="addMovieForm.language" placeholder="请输入语言" clearable></el-input>
      </el-form-item>

      <el-form-item label="上映时间" prop="releaseTime">
        <el-input v-model="addMovieForm.releaseTime" placeholder="请输入上映时间" clearable></el-input>
      </el-form-item>

      <el-form-item label="时长" prop="duration">
        <el-input v-model="addMovieForm.duration" placeholder="请输入时长" clearable></el-input>
      </el-form-item>

      <el-form-item label="更多片名" prop="moreName">
        <el-input v-model="addMovieForm.moreName" placeholder="请输入更多片名" clearable></el-input>
      </el-form-item>

      <el-form-item label="简介" prop="intro">
        <el-input v-model="addMovieForm.intro" placeholder="请输入简介" clearable></el-input>
      </el-form-item>

      <el-form-item label="豆瓣评分" prop="douban">
        <el-input v-model="addMovieForm.douban" placeholder="请输入豆瓣评分" clearable></el-input>
      </el-form-item>
      <el-form-item label="IMDb评分" prop="IMDb">
        <el-input v-model="addMovieForm.IMDb" placeholder="请输入IMDb评分" clearable></el-input>
      </el-form-item>
      <el-form-item label="出品商" prop="producer">
        <el-input v-model="addMovieForm.producer" placeholder="请输入出品商" clearable></el-input>
      </el-form-item>

      <el-form-item label="封面" prop="coverImage">
        <el-input v-model="addMovieForm.coverImage" placeholder="请输入封面图" clearable></el-input>
      </el-form-item>

      <el-form-item label="顶部图片" prop="titleImage">
        <el-input v-model="addMovieForm.titleImage" placeholder="请输入标题图" clearable></el-input>
      </el-form-item>

      <el-form-item>
        <el-button class="button-container" type="primary" @click="onSubmit('addMovieForm')">提交</el-button>
        <el-button class="button-container" @click="resetForm('addMovieForm')">重置</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
  name: 'BackAddMovie',
  data () {
    return {
      addMovieForm: {
        movieName: '',
        englishName: '',
        years: 0,
        orginPlace: [],
        category: [],
        language: [],
        releaseTime: [],
        duration: 0,
        moreName: [],
        intro: [],
        douban: 0,
        IMDb: 0,
        producer: [],
        coverImage: '',
        titleImage: ''
      },
      rules: {
        movieName: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        englishName: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        years: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        orginPlace: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        category: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        language: [
          {required: true, message: '详细地址不可为空', trigger: 'blur'}
        ],
        releaseTime: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        duration: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        moreName: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        intro: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        douban: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        IMDb: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        producer: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        coverImage: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ],
        titleImage: [
          {required: true, message: '联系人不可为空', trigger: 'blur'}
        ]
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/movie/BackAddMovie.vue